import React from 'react';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import RenderDropdown from 'forms/RenderDropdown';
import { selectFertilizerProductsOptions } from './selectors';

export interface Props {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
}

export default function FertilizerProductsDropdown(
    props: Props
): React.ReactElement {
    const { name, label, validate, nullOnUnmount = false } = props;

    const options = useSelector(selectFertilizerProductsOptions);

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            label={label || 'Product'}
            placeholder="Choose a product"
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            options={options}
            nullOnUnmount={nullOnUnmount}
        />
    );
}
